import type { HttpInterceptorFn } from '@angular/common/http';
import { Logger } from '@app/utils';

const logger: Logger = Logger.get('CredentialsInterceptor');

export const credentialsInterceptor: HttpInterceptorFn = (request, next) => {
  // Ensure credentials are included with all requests
  const credentialedRequest = request.clone({
    withCredentials: true
  });

  logger.debug('CredentialsInterceptor - Intercepting request:', credentialedRequest);

  return next(credentialedRequest);
};
